module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Quick Example",
      "theme": "box-primary",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "title": "Email address",
      "vaId": "exampleInputEmail1",
      "type": "email",
      "placeholder": "Enter email"
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "Password",
      "vaId": "exampleInputPassword1",
      "type": "password",
      "placeholder": "Password"
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "File input",
      "vaId": "exampleInputFile",
      "type": "file",
      "helpBlock": "Example block-level help text here."
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Check me out..."
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Different Height",
      "theme": "box-success",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input', {
    attrs: {
      "size": "lg",
      "placeholder": ".input-lg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input', {
    attrs: {
      "placeholder": "Default input"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input', {
    attrs: {
      "size": "sm",
      "placeholder": ".input-sm"
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Different Width",
      "theme": "box-danger",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('column', {
    staticClass: "col-xs-3"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-3"
    }
  })], 1), _vm._v(" "), _c('column', {
    staticClass: "col-xs-4"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-4"
    }
  })], 1), _vm._v(" "), _c('column', {
    staticClass: "col-xs-5"
  }, [_c('va-input', {
    attrs: {
      "placeholder": ".col-xs-5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Input Addon",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Username",
      "prefixAddonText": "@"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "prefixAddonText": "$",
      "suffixAddonText": ".00"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("With icons")]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholder": "Email",
      "type": "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar",
    attrs: {
      "slot": "slotPrefixAddonText"
    },
    slot: "slotPrefixAddonText"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ambulance",
    attrs: {
      "slot": "slotSuffixAddonText"
    },
    slot: "slotSuffixAddonText"
  })]), _vm._v(" "), _c('h4', [_vm._v("With checkbox and radio inputs")]), _vm._v(" "), _c('row', [_c('column', {
    staticClass: "col-lg-6"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('input', {
    attrs: {
      "slot": "slotPrefixAddonText",
      "type": "checkbox"
    },
    slot: "slotPrefixAddonText"
  })])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-lg-6"
  }, [_c('va-input-group', {
    attrs: {
      "groupType": "input"
    }
  }, [_c('input', {
    attrs: {
      "slot": "slotPrefixAddonText",
      "type": "radio"
    },
    slot: "slotPrefixAddonText"
  })])], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("With buttons")]), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Large: "), _c('code', [_vm._v(".input-group.input-group-lg")])]), _vm._v(" "), _c('va-input-group', {
    staticClass: "input-group-lg",
    attrs: {
      "groupType": "input"
    }
  }, [_c('va-button', {
    staticClass: "dropdown-toggle",
    attrs: {
      "slot": "slotPrefixButton",
      "name": "Action",
      "theme": "warning",
      "data-toggle": "dropdown"
    },
    slot: "slotPrefixButton"
  }, [_vm._t("default", [_c('span', {
    staticClass: "fa fa-caret-down"
  })])], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "slotPrefixDropdown"
    },
    slot: "slotPrefixDropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholer": ""
    }
  }, [_c('va-button', {
    attrs: {
      "slot": "slotPrefixButton",
      "name": "Action",
      "theme": "danger"
    },
    slot: "slotPrefixButton"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "margin"
  }, [_vm._v("Small "), _c('code', [_vm._v(".input-group.input-group-sm")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "groupType": "input",
      "placeholer": ""
    }
  }, [_c('va-button', {
    attrs: {
      "slot": "slotSuffixButton",
      "name": "Go!",
      "theme": "info"
    },
    slot: "slotSuffixButton"
  })], 1)], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Horizontal Form",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('va-input', {
    attrs: {
      "isHorizontal": true,
      "title": "Email",
      "placeholder": "Email",
      "type": "email",
      "vaId": "horizontal-email"
    }
  }), _vm._v(" "), _c('va-input', {
    attrs: {
      "isHorizontal": true,
      "title": "Password",
      "placeholder": "Password",
      "type": "password",
      "vaId": "horizontal-email"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "isHorizontal": true,
      "text": "Check me out..."
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "name": "Cancel"
    }
  }), _vm._v(" "), _c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "info",
      "align": "right",
      "name": "Sign in"
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "General Elements",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-input-group', {
    attrs: {
      "title": "Text",
      "vaId": "ge-text-input",
      "placeholder": "Enter ..."
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "title": "Text Disabled",
      "vaId": "ge-text-input-disabled",
      "placeholder": "Enter ...",
      "isDisabled": true
    }
  }), _vm._v(" "), _c('va-textarea-group', {
    attrs: {
      "title": "Textarea",
      "isDisabled": true,
      "placeholder": "Enter ..."
    }
  }), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "success",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Input with success")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "warning",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" Input with warning")])]), _vm._v(" "), _c('va-input-group', {
    attrs: {
      "theme": "error",
      "helpBlock": "Help block with success"
    }
  }, [_c('label', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" Input with error")])]), _vm._v(" "), _c('va-form-group', [_c('va-checkbox', {
    attrs: {
      "text": "Checkbox 1"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Checkbox 2"
    }
  }), _vm._v(" "), _c('va-checkbox', {
    attrs: {
      "text": "Checkbox disabled",
      "isDisabled": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios1",
      "value": "option1",
      "isChecked": true
    }
  }, [_vm._v("\n            Option one is this and that—be sure to include why it's great\n          ")]), _vm._v(" "), _c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios2",
      "value": "option2"
    }
  }, [_vm._v("\n            Option two can be something else and selecting it will deselect option one\n          ")]), _vm._v(" "), _c('va-radio', {
    attrs: {
      "name": "optionsRadios",
      "vaId": "optionsRadios3",
      "value": "option3",
      "isDisabled": true
    }
  }, [_vm._v("\n            Option three is disabled\n          ")])], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Disabled")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isDisabled": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Multiple")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isMultiple": true
    }
  })], 1), _vm._v(" "), _c('va-form-group', [_c('label', [_vm._v("Select Multiple Disabled")]), _vm._v(" "), _c('va-select', {
    attrs: {
      "list": _vm.selectList,
      "isMultiple": true,
      "isDisabled": true
    }
  })], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d08e6d46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forms/GeneralElements.vue
// module id = 747
// module chunks = 1